module.exports = __webpack_public_path__ + "static/intro-15080ed7c3c26814f81bfc13770ad707.mp4";